import { Actions, ActionTypes } from '@appStore/selfservice/actions';
import { BookingService, CustomQuestion, SchedulingPolicy, StaffAvailability } from "@model";

export interface State{
    bookingServices: BookingService[];
    bookingServicesLoading: boolean;
    bookingServicesLoaded: boolean;
    selectedService: BookingService;
    scheduingPolicy: SchedulingPolicy;
    schedulingPolicyLoading: boolean;
    schedulingPolicyLoaded: boolean;
    staffIds: string[];
    staffsLoading: boolean;
    staffsLoaded: boolean;
    staffAvailability: StaffAvailability[],
    staffAvailabilityLoading: boolean,
    staffAvailabilityLoaded: boolean,
    appointmentCreated: boolean;
    appointmentCreating: boolean;
    serviceCustomQuestions: CustomQuestion[];
    serviceCustomQuestionsLoading: boolean;
    serviceCustomQuestionsLoaded: boolean;
}

export const initialState: State = {
    bookingServices: [],
    bookingServicesLoading: false,
    bookingServicesLoaded: false,
    selectedService: null,
    scheduingPolicy: null,
    schedulingPolicyLoading: false,
    schedulingPolicyLoaded: false,
    staffIds: [],
    staffsLoading: false,
    staffsLoaded: false,
    staffAvailability: [],
    staffAvailabilityLoading: false,
    staffAvailabilityLoaded: false,
    appointmentCreated: false,
    appointmentCreating: false,
    serviceCustomQuestions: [],
    serviceCustomQuestionsLoading: false,
    serviceCustomQuestionsLoaded: false
};

export function reducer(state = initialState, action: Actions): State {
    switch(action.type) {
        case ActionTypes.BookingServicesLoad:
            return {...state, bookingServicesLoaded: false, bookingServicesLoading: true };
        case ActionTypes.BookingServicesLoadSuccess:
            return { ...state, bookingServicesLoaded: true, bookingServicesLoading: false, bookingServices: action.payload };
        case ActionTypes.BookingServicesLoadFail:
            return { ...state, bookingServicesLoaded: false, bookingServicesLoading: false, bookingServices: [] };
        case ActionTypes.SelectService:
            return {...state, selectedService: action.payload, staffIds: [], staffsLoaded: false, staffsLoading: false, staffAvailability: [], staffAvailabilityLoaded: false, staffAvailabilityLoading: false };
        case ActionTypes.SchedulingPolicyLoad:
            return { ...state, schedulingPolicyLoaded: false, schedulingPolicyLoading: true, scheduingPolicy: null };
        case ActionTypes.SchedulingPolicyLoadSuccess:
            return { ...state, schedulingPolicyLoaded: true, schedulingPolicyLoading: false, scheduingPolicy: action.payload };
        case ActionTypes.SchedulingPolicyLoadFail:
            return {...state, schedulingPolicyLoaded: false, schedulingPolicyLoading: false, scheduingPolicy: null };
        case ActionTypes.StaffsLoad:
            return { ...state, staffsLoaded: false, staffsLoading: true, staffIds: [] };
        case ActionTypes.StaffsLoadSuccess:
            return { ...state, staffsLoaded: true, staffsLoading: false, staffIds: !!action.payload && action.payload.length > 0  ? action.payload.map(staff => staff.id) : [] };
        case ActionTypes.StaffsLoadFail:
            return { ...state, staffsLoaded: false, staffsLoading: false, staffIds: [] };
        case ActionTypes.StaffAvailabilityLoad:
            return { ...state, staffAvailabilityLoaded: false, staffAvailabilityLoading: true, staffAvailability: [] };
        case ActionTypes.StaffAvailabilityLoadSuccess:
            return { ...state, staffAvailabilityLoaded: true, staffAvailabilityLoading: false, staffAvailability: action.payload };
        case ActionTypes.StaffAvailabilityLoadFail:
            return { ...state, staffAvailabilityLoaded: false, staffAvailabilityLoading: false, staffAvailability: [] };
        case ActionTypes.CreateAppointment:
            return {...state, appointmentCreated: false, appointmentCreating: true };
        case ActionTypes.CreateAppointmentSuccess:
            return {...state, appointmentCreated: true, appointmentCreating: false };
        case ActionTypes.CreateAppointmentFail:
            return {...state, appointmentCreated: false, appointmentCreating: false };
        case ActionTypes.ClearAppointment:
            return {...state, selectedService: null, serviceCustomQuestions: [], serviceCustomQuestionsLoaded: false, serviceCustomQuestionsLoading: false, scheduingPolicy: null, staffIds: [], staffsLoaded: false, staffsLoading: false, schedulingPolicyLoaded: false, schedulingPolicyLoading: false, appointmentCreated: false, appointmentCreating: false };
        case ActionTypes.ServiceCustomQuestionsLoad:
            return {...state, serviceCustomQuestionsLoading: true, serviceCustomQuestionsLoaded: false, serviceCustomQuestions: [] };
        case ActionTypes.ServiceCustomQuestionsLoadSuccess:
            return {...state, serviceCustomQuestionsLoading: false, serviceCustomQuestionsLoaded: true, serviceCustomQuestions: action.payload };
        case ActionTypes.ServiceCustomQuestionsLoadFail:
            return {...state, serviceCustomQuestionsLoading: false, serviceCustomQuestionsLoaded: false, serviceCustomQuestions: [] };
    }

    return state;
}

export const getBookingServices = (state: State) => state.bookingServices;
export const getBookingServicesLoading = (state: State) => state.bookingServicesLoading;
export const getBookingServicesLoaded = (state: State) => state.bookingServicesLoaded;

export const getServiceCustomQuestions = (state: State) => state.serviceCustomQuestions;
export const getServiceCustomQuestionsLoading = (state: State) => state.serviceCustomQuestionsLoading;
export const getServiceCustomQuestionsLoaded = (state: State) => state.serviceCustomQuestionsLoaded;

export const getSelectedService = (state: State) => state.selectedService;

export const getSchedulingPolicy = (state: State) => state.scheduingPolicy;
export const getSchedulingPolicyLoading = (state: State) => state.schedulingPolicyLoading;
export const getSchedulingPolicyLoaded = (state: State) => state.schedulingPolicyLoaded;

export const getStaffs = (state: State) => state.staffIds;
export const getStaffsLoaded = (state: State) => state.staffsLoaded;
export const getStaffsLoading = (state: State) => state.staffsLoading;

export const getStaffAvailability = (state: State) => state.staffAvailability;
export const getStaffAvailabilityLoading = (state: State) => state.staffAvailabilityLoading;
export const getStaffAvailabilityLoaded = (state: State) => state.staffAvailabilityLoaded;

export const getAppointmentCreated = (state: State) => state.appointmentCreated;
export const getAppointmentCreating = (state: State) => state.appointmentCreating;